import Cookie from "./Cookie";

export default class Language {
    static getLanguage() {
        let language = document.querySelector('html').getAttribute('lang');

        if (language !== null && language !== undefined || language !== '') {
            return language;
        }

        language = Cookie.get('pll_language', 'pt');

        switch (language) {
            case 'pt': return 'pt-BR';
            case 'en': return 'en-US';
            default: return 'pt-BR';
        }
    }

    static isPortuguese() {
        return this.getLanguage() === 'pt-BR';
    }
}
